import { create } from 'zustand';
import { AuthState } from '@/shared/domain/types';

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: false,
  
  logout: async () => {
    // Limpiar tokens OAuth2 de forma asíncrona
    const { oauth2Service } = await import('@/features/auth/infrastructure/api/oauth2.service');
    const tokens = oauth2Service.getTokens();
    
    // Revocar tokens en el servidor si están disponibles
    if (tokens?.access_token) {
      try {
        await oauth2Service.revokeToken(tokens.access_token, 'access_token');
      } catch (error) {
        console.error('Error al revocar access token:', error);
      }
    }
    
    if (tokens?.refresh_token) {
      try {
        await oauth2Service.revokeToken(tokens.refresh_token, 'refresh_token');
      } catch (error) {
        console.error('Error al revocar refresh token:', error);
      }
    }
    
    // Limpiar tokens de memoria y cookies
    oauth2Service.clearTokens();
    
    // Limpiar también token legacy
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    
    set({ 
      user: null, 
      isAuthenticated: false 
    });
  },
  
  setUser: (user) => set({ 
    user, 
    isAuthenticated: !!user 
  }),
  setLoading: (loading) => set({ isLoading: loading }),
}));
